<template>
  <div>
    <result-pay :url="url" business-type="yx"/>
  </div>
</template>

<script>
import ResultPay from './../page/result-pay';
import Api from './api';
export default {
  name: 'ResultPayVue',
  components: {
    ResultPay
  },
  data () {
    return {
      url: Api.YXPREFIX
    };
  },
  mounted () {},
  created () {},
  methods: {}
};
</script>
